import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';

import { EquipmentDetailsView } from '@/features/equipment-browser/equipment-details/equipment-details-view';
import { useEquipmentDetailsRouteState } from '@/features/equipment-browser/equipment-details/hooks/use-equipment-details-route-state';
import { useEquipmentPool } from '@/features/equipment-browser/equipment-details/hooks/use-equipment-pool';
import { useEquipmentResponseLoader } from '@/features/equipment-browser/equipment-details/hooks/use-equipment-response-loader';
import { equipmentPoolAtom } from '@/features/equipment-browser/equipment-details/state/selected-equipment.state';

type EquipmentDetailsDrawerProps = {
  onClose: () => void;
};

export const EquipmentDetailsDrawer = ({
  onClose,
}: EquipmentDetailsDrawerProps): React.ReactNode => {
  const { equipmentId } = useEquipmentDetailsRouteState();
  const equipmentPool = useAtomValue(equipmentPoolAtom);

  useEquipmentPool();
  useEquipmentResponseLoader({
    equipmentId: equipmentId ?? '',
  });

  const equipment = useMemo(
    () => equipmentPool.find((summary) => summary.referenceId === equipmentId),
    [equipmentId, equipmentPool]
  );

  if (!equipmentId || !equipment) {
    return null;
  }

  return <EquipmentDetailsView onClose={onClose} equipment={equipment} />;
};
